import { extend, $$, $ } from './helper-functions'
import Splide from '@splidejs/splide'

export class GalleryVariant3 {
  constructor (settings, selectors, classes) {
    this.settings = extend({}, settings)

    this.selectors = extend({
      block: '.gallery--variant-3',
      item: '.gallery__item',
      countCurrent: '.gallery__count-current',
      countAll: '.gallery__count-all'
    }, selectors)

    this.classes = extend({
    }, classes)

    this.galleries = $$(this.selectors.block)
  }

  init () {
    this.events()
  }

  events () {
    this.galleries.forEach(gallery => {
      const items = $$(this.selectors.item, gallery)
      const countCurrent = $(this.selectors.countCurrent, gallery)
      const countAll = $(this.selectors.countAll, gallery)

      countCurrent.innerText = 1
      countAll.innerText = items.length

      new Splide(gallery, {
        type: 'slide',
        perPage: 1,
        speed: 500,
        pagination: false
      })
        .mount()
        .on('move', (index) => {
          countCurrent.innerText = index + 1
        })
    })
  }
}

export default GalleryVariant3
